export default __webpack_public_path__ + "static/media/shovel.747b3c79.png";